import "./suggestion.scss";
import { useQuery } from '@tanstack/react-query';
import { makeRequest } from "../../axios";
import { useState } from "react";
import { getImageUrl } from "../../utils/getImageUrl"
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { useContext } from "react";

const Suggestion = ({ unfollowedUsers }) => {
  const [unfollowedInfo, setUnfollowedInfo] = useState([{profilePic: '', name: ''}])
  const { currentUser } = useContext(AuthContext);
  

  const handleClick = async (userId) => {
    const res = await makeRequest.post("/relationships", { userId });
    window.location.reload(true);
  }

  return (
    <div className="suggestion">
      <div className="suggestionContainer">
        <div className="item">
          <span>Accounts to Follow</span>
          {unfollowedUsers.map((suggestion) => 
            <div className="user" key={suggestion.id}>
              <div className="userInfo">
                {suggestion.profilePic === null
                  ?
                    <Link to={"/profile/" + suggestion.id} style={{ textDecoration: "none" }}>
                      <img src={"/defaultProfile.jpg"} alt="" />
                    </Link>
                  :
                    <Link to={"/profile/" + suggestion.id} style={{ textDecoration: "none" }}>
                      <img src={getImageUrl("profile", suggestion.profilePic)} alt="" />
                    </Link>
                }
                <span>{suggestion.name}</span>
              </div>
              <div className="buttons">
                <button onClick={()=> handleClick(suggestion.id)}>Follow</button>
              </div>
            </div> 
          )}
        </div>
      </div>
    </div>
  );
};

export default Suggestion;
